import { EquipmentDataService } from '../infrastructure/equipments/equipment.data.service';
import {
    EquipmentCreate,
    EquipmentDto,
    EquipmentRead,
    EquipmentSearchParams,
} from '../entities/equipment.dto';
import { EquipmentStore } from '../infrastructure/equipments/equipment.store';
import { Injectable, inject } from '@angular/core';
import { RoutesForEquipment } from './equipment.routes';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { EquipmentMapper } from '../infrastructure/equipments/equipment.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';

@Injectable()
export class EquipmentFacade extends AbstractManageEntityFacade<
    EquipmentDto,
    EquipmentRead,
    EquipmentCreate,
    EquipmentSearchParams
> {
    nameField: keyof EquipmentDto = 'number';

    constructor() {
        const dataService = inject(EquipmentDataService);
        const routes = inject(RoutesForEquipment);
        const store = inject(EquipmentStore);
        const mapper = inject(EquipmentMapper);

        super(dataService, routes, store, mapper);
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof EquipmentDto, string>> {
        return { number: searchText };
    }
}
